import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#1B4332] text-white text-center" data-id="element-100">
      <div className="max-w-4xl mx-auto" data-id="element-101">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-102">
          Cada Día Que Pasa Sin Un Sistema Claro, Tu Diabetes Decide Por Vos
        </h2>
        <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto" data-id="element-103">
          Hoy podés elegir dejar de improvisar. Tener un plan. Saber qué comer,
          qué comprar y cómo vivir — con confianza, no con miedo. Todo lo que
          necesitás está en este pack.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-104">
          <CTAButton text="QUIERO TOMAR EL CONTROL HOY" size="xl" className="bg-[#D97706] hover:bg-[#B45309] text-white shadow-xl" data-id="element-105" />

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-106">
            <span className="flex items-center gap-1" data-id="element-107">
              <CheckCircle className="w-4 h-4 text-[#86EFAC]" data-id="element-108" /> Acceso
              inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-109">
              <CheckCircle className="w-4 h-4 text-[#86EFAC]" data-id="element-110" /> Garantía de 7
              días
            </span>
            <span className="flex items-center gap-1" data-id="element-111">
              <CheckCircle className="w-4 h-4 text-[#86EFAC]" data-id="element-112" /> Más de 2,000
              personas ya lo tienen
            </span>
          </div>
        </div>
      </div>
    </section>;
}